<template>
  <button type="submit" :class="buttonStyle({ primary: !props.disabled, disabled: props.disabled })" :disabled="props.disabled" @click.prevent="props.onClick">
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
import { tv } from 'tailwind-variants';

interface Props {
  disabled?: boolean;
  onClick: () => void;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  onClick: () => {},
});

const buttonStyle = tv({
  base: `cursor-pointer self-center break-keep text-gold1 underline transition-all duration-300 ease-linear focus:ring-0`,
  variants: {
    primary: {
      true: 'hover:opacity-50',
    },
    disabled: {
      true: 'cursor-default border-gray2 bg-gray1 text-gray2 ',
    },
  },
});
</script>
